import { render } from "./MemoruContentCard.vue?vue&type=template&id=46d9aec2&ts=true"
import script from "./MemoruContentCard.vue?vue&type=script&lang=ts"
export * from "./MemoruContentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__